export default {"src":"/_next/static/media/rubika.159ee2a2.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};